var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    {
      '--overlay': _vm.overlay,
      '--horizontal': _vm.horizontal,
      '--locked': !_vm.isLoading,
      '--scheduled': _vm.isScheduled
    },
    'access-lock p-absolute d-flex align-items-center justify-content-center'
  ],attrs:{"data-cy":"access-lock"}},[(_vm.isLoading)?[_c('v-loader',{attrs:{"white":"","thin":""}})]:[_c('v-icon',{attrs:{"icon":"lock","size":"1rem"}}),(_vm.isScheduled)?_c('span',{staticClass:"d-inline-block text-small font-weight-semi-bold access-lock__time"},[_vm._v(_vm._s(_vm.timeAgo(_vm.availableAfter, true)))]):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }